import React, { useState, useEffect, Fragment } from 'react'
import { useGlobal } from 'reactn';
import 'leaflet/dist/leaflet.css';
import HeaderBar from '../../../components/atoms/headerBar/HeaderBar';
import SideBar from '../../../components/atoms/sideBar/SideBar';
import Mapper from '../../../components/organisms/mapper/Mapper';
import DropDown from '../../../components/atoms/dropdown/Dropdown';
import LayerControl from '../../../components/molecules/layerControl/LayerControl';
import OverlayControl from '../../../components/molecules/overlayControl/OverLayControl';
import StatsPanel from "../../../components/organisms/statsPanel/StatsPanel";
import getStateNode from '../../../helpers/getStateNode'
import styles from './Home.module.scss'

const Home = () => {
  const [selectedState, setselectedState] = useState('National')
  const [selectedPosition, setselectedPosition] = useState([9.0820, 8.6753])
  const [stateLevel, setstateLevel] = useState(false)
  const [masterFile, setMasterFile] = useState(undefined)
  // eslint-disable-next-line
  const [, setshowDataLookup] = useGlobal('showDataLookup')

  // master data from data repo
  useEffect(() => {
    if (masterFile === undefined) {
        const loadMasterData = async () => {
            fetch('https://flowminder.github.io/school-optimisation-resources-nigeria/summary/stateDataMaster.json')
                .then(response => response.json())
                .then((jsonData) => {
                    setMasterFile(jsonData)
                })
                .catch((error) => {
                    console.error(error)
                })
        }
        loadMasterData()
    }
}, [masterFile, setMasterFile])

  const handleChange = (selectedValue, selectedCoords) => {
    setshowDataLookup([])
    if (selectedValue) {
      setselectedState(selectedValue)
      selectedValue === 'National' ? setstateLevel(false) : setstateLevel(true)
    }
    if (selectedCoords) {
      setselectedPosition(selectedCoords)
    }
  }

  const getStateOptions = () => {
    const stateData = require('../../../assets/data/nigeriaStateNames')
    const stateOptions = stateData.stateNames
    return stateOptions
  }

  const getStateData = (masterFile) => {
    const stateReports = `${selectedState.toLowerCase()}.reports`
    const selectedStateReports = getStateNode(masterFile, stateReports);
    return selectedStateReports
  }

  const getOverlayData = (masterFile) => {
    const overlayPath = `national.overlays`
    const overlays = getStateNode(masterFile, overlayPath);
    return overlays
  }

    return (
    <Fragment>
      <Mapper mapPosition={selectedPosition} selectedState={selectedState} />
      <div className="NavContainer">
        <HeaderBar />
      </div>
      <div className="ContentLeft">
        <SideBar position={'left'} wide={true}>
        <p className={styles.explanation}></p>
          <DropDown options={getStateOptions()} onChange={handleChange}/>
          {stateLevel &&
            <LayerControl data={getStateData(masterFile)} selectedState={selectedState} />
          }
          <OverlayControl data={getOverlayData(masterFile)} />
        </SideBar>
      </div>
      <div className="ContentRight">
        <SideBar position={'right'} wide={true}>
          <StatsPanel masterFile={masterFile} selectedState={selectedState} />
        </SideBar>
      </div>
    </Fragment>
    );
}

export default Home
